
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as GarageInvoiceModels from '../../models/garage-invoice/garage-invoice';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { CorrectionRequest } from './garage-invoice.action';

@Injectable({
  providedIn: 'root'
})

export class GarageInvoiceService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public get(Search: GarageInvoiceModels.GarageInvoiceSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageInvoiceModels.GarageInvoiceListModel>(`${this.environmentService.getApiURL()}/garage-invoice/list`, Search, options);
  }

  public getLinkedSpecifications(GarageInvoiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };
    // tslint:disable-next-line: max-line-length
    return this.httpClient.get<GarageInvoiceModels.LinkedSpecificationListModel>(`${this.environmentService.getApiURL()}/garage-invoice/specifications/list/${GarageInvoiceId}`, options);
  }

  public delete(GarageInvoiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };
    return this.httpClient.get<HttpEventType>(`${this.environmentService.getApiURL()}/garage-invoice/garage-invoice/delete/${GarageInvoiceId}`, options);
  }

  public insert(GarageInvoice: GarageInvoiceModels.GarageInvoiceModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    return this.httpClient.post<HttpEventType>(`${this.environmentService.getApiURL()}/garage-invoice/insert`, GarageInvoice, { observe: 'events' });
  }


  public getPrintData(GarageInvoiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };
    // tslint:disable-next-line: max-line-length
    return this.httpClient.get<GarageInvoiceModels.PrintDataListModel>(`${this.environmentService.getApiURL()}/garage-invoice/garage-invoice/print/${GarageInvoiceId}`, options);
  }

  public getCompactPrintData(GarageInvoiceId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };
    // tslint:disable-next-line: max-line-length
    return this.httpClient.get<GarageInvoiceModels.PrintDataListModel>(`${this.environmentService.getApiURL()}/garage-invoice/garage-invoice/compactprint/${GarageInvoiceId}`, options);
  }

  public correctionRequest(Correction: GarageInvoiceModels.GarageInvoiceCorrectionModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post(
      `${this.environmentService.getApiURL()}/garage-invoice/garage-invoice/correction-request`,
      Correction,
      options
    );
  }

  public getReport(Search: GarageInvoiceModels.GarageInvoiceSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/garage-invoice/report`, Search, options);
  }
}
